import deepMerge from 'deepmerge';
import { PartialDeep } from 'type-fest';

import { Theme, ComponentsVariants, theme } from '../themeBase';

type Components = keyof Theme['components'];

class ThemeUtilities {
  /**
   * Creates a new theme definition
   */
  public static createTheme(partialTheme: PartialDeep<Theme> = null): Theme {
    if (partialTheme)
      return deepMerge(theme, partialTheme, {
        arrayMerge: (destinationArray, sourceArray) => sourceArray,
      }) as Theme;
    return theme;
  }

  /**
   * Get CSS override object from theme for specific component
   */
  public static getComponentCSSOverrides(
    { theme }: { theme: Theme },
    component: Components
  ) {
    return theme.components[component]?.cssOverrides;
  }

  /**
   * Get variant settings for specific component
   */
  public static getComponentVariant(
    { theme }: { theme: Theme },
    component: Components,
    variant: ComponentsVariants
  ): Record<string, any> {
    const { components } = theme;
    const componentSettings: Record<string, any> =
      components[component]?.componentVariants;
    return componentSettings[variant];
  }
}

export default ThemeUtilities;
